<app-kymw1400-koma-page id="KYMW1400KomaPageRightViewHelper" #KYMW1400KomaPageRightViewHelper [leftOrRight]="'right'"
  (mousedown)="eventWindow_MOUSE_DOWNHandler()">
</app-kymw1400-koma-page>
